import { Action } from "../../common/actions/core/action";


export class OpenCampaignDialogAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/campaign-dialog/campaign-dialog.action.ts